module.exports = __webpack_public_path__ + "paleVennTriangleIcon.4a8ad11a93e3282a7ace255dea0faed5.png";